import { Component, OnInit, OnChanges, SimpleChanges, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../../../../../auth/user.service';
import { SiteDashboardService } from '../../../site-dashboard.service';
import { PlinksDashboardService } from '../plinks-dashboard.service';
import { DevicesDashboardService } from '../../../devices/devices-dashboard.service';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import * as moment from 'moment';
import { CommonUtil } from '../../../../../shared/services/utility/common.service';

@Component({
  selector: 'app-plink-debug-records',
  templateUrl: './plink-debug-records.component.html',
  styleUrls: ['./plink-debug-records.component.css']
})
export class PlinkDebugRecordsComponent {
@Input() device: any = {};
  @Input() deviceType: string = 'plink';
  @Input() date: {
    fromDate: any,
    toDate: any
  } = {
    fromDate: null,
    toDate: null
  };

  @Output() updateAppearanceElementsFlags = new EventEmitter<any>(true);

  plinkID: number = 0;
  PlinkData: any = {};
  currentUser: any = {};
  prevToDate: any;
  prevFromDate: any;
  intervalID: any;
  settings: any = {
    height: "500"
  }

  // Grid configurations
  DebugRecordsGridColumns = [];
  DebugRecordsGridData = [];

  // Energy format tracking
  // energyAnalysis: any = null;
  // currentEnergyFormat: string = 'unknown';

  constructor(
    private router: Router,
    private userService: UserService,
    private siteDashboardService: SiteDashboardService,
    private plinksDashboard: PlinksDashboardService,
    private devicesDashboard: DevicesDashboardService,
    private translateService: TranslateService,
    private http: HttpClient,
    private commonUtil: CommonUtil
  ) { }

  ngOnInit() {
    this.currentUser = this.userService.getCurrentUser();
    // this.siteDashboardService.setActiveSubTab('plink-rt-records');

    // Initialize grid columns
    this.initializeGridColumns();

    // Set up appearance flags for the select-plink component
    this.updateAppearanceElementsFlags.emit({
      addNoteEnabled: false,
      pageHasFilterByDate: true,
      pageHasBattviewTags: true,
      hasResetPLC: false,
      pageHasManageBtn: true,
      pageHasTimesInfo: true,
    });

    // Initialize data structure
    this.initializePlinkData();

    // Get initial data
    this.getEventsData();

    // // Set up auto-refresh interval
    // this.intervalID = setInterval(() => {
    //   if(this.plinkID)
    //     this.fetchPlinkData('MostRecent');
    // }, 60000); // Send ajax call every 1 minute
  }

  ngOnChanges(changes: SimpleChanges) {
    // Trigger API call when either device or date changes
    if ((changes['device'] && changes['device'].currentValue) ||
        (changes['date'] && changes['date'].currentValue)) {
      this.getEventsData();
    }
  }

  ngOnDestroy() {
    if(this.intervalID) {
      clearInterval(this.intervalID);
    }
  }

  initializeGridColumns() {
    const debugRecordsColumns = [
      {headerName: 'ID', field: 'id', flex: 1, type: 'number'},
      {headerName: 'Time', field: 'recordTimeFormatted', flex: 2},
      {headerName: 'Info', field: 'info', flex: 1, type: 'number'},
      {headerName: 'Debug', field: 'debugText', flex: 3},
      {headerName: 'Zone', field: 'zoneid', flex: 1},
    ];

    this.DebugRecordsGridColumns = [...debugRecordsColumns];
  }

  initializePlinkData() {
    this.PlinkData = {
      fromDate: 0,
      toDate: 0,
      fromDateFmt: null,
      toDateFmt: null,
      lastRTRecordID: 0,
      rtRecordsMinDate: 0
    };

    this.DebugRecordsGridData = [];
  }

  onDeviceChanged(device) {
    this.device = device;
    this.getEventsData();
  }

  onDatesUpdated(date) {
    this.date = date;
    this.getEventsData();
  }

  getEventsData() {
    // Check for device ID in both possible property names and handle string/number conversion
    const rawDeviceId = this.device?.deviceid || this.device?.id;
    const deviceId = rawDeviceId ? parseInt(rawDeviceId.toString(), 10) : null;

    if (!deviceId) {
      console.log('No device ID available for Debug Records');
      return;
    }

    this.plinkID = deviceId;

    // Initialize data if needed
    if (!this.PlinkData || Object.keys(this.PlinkData).length === 0) {
      this.initializePlinkData();
    }

    // Set up date range
    this.filterPlinkData();

    // Fetch data
    this.fetchPlinkData('DateRange');
  }

  filterPlinkData() {
    if(!this.device || !this.device.deviceid) {
      return;
    }

    // Use date range from input or default to last 7 days
    let fromDate, toDate;
    
    if (this.date && this.date.fromDate && this.date.toDate) {
      fromDate = new Date(this.date.fromDate);
      toDate = new Date(this.date.toDate);
      fromDate.setHours(0,0,0,0);
      toDate.setHours(23,59,59,999); // Set to midnight 
    } else {
      // Default to last 7 days
      toDate = new Date();
      fromDate = new Date();
      fromDate.setDate(fromDate.getDate() - 7);
    }

    this.PlinkData.fromDate = Math.floor(fromDate.getTime() / 1000);
    this.PlinkData.toDate = Math.floor(toDate.getTime() / 1000);
    this.PlinkData.fromDateFmt = fromDate;
    this.PlinkData.toDateFmt = toDate;
  }

  fetchPlinkData(from) {
    if(!this.plinkID) {
      return;
    }

    var fromDate = this.PlinkData.fromDate;
    var plinkID = this.plinkID;
    var toDate = 0;
    var lastID = 0;

    if(from === 'DateRange') {
      // For date range queries, use the actual date range
      toDate = this.PlinkData.toDate;
    } else {
      // For 'MostRecent' queries, use the min date and last ID for pagination
      toDate = this.PlinkData.rtRecordsMinDate;
      lastID = this.PlinkData.lastRTRecordID;
    }

    const DebugInfo = {
      DEBUG_KEY_RTC_FAILURE: 9,
      DEBUG_KEY_WIFI_RESTART: 10,
      DEBUG_KEY_RTC_STARTUP: 12,
      DEBUG_KEY_WIFI_STARTUP: 14,
      DEBUG_KEY_UPNORMAL_RESET: 16,

    }

    this.plinksDashboard.getPolarLinkDebugRecords(plinkID, fromDate, toDate).subscribe(
      (result: any) => {

        if(result && result?.data && result.data.length > 0) {

          function formatTimestampToYMDHMS(unixSeconds) {
            const date = new Date(unixSeconds * 1000);

            return date.getUTCFullYear() + "-" +
            String(date.getUTCMonth() + 1).padStart(2, '0') + "-" +
            String(date.getUTCDate()).padStart(2, '0') + " " +
            String(date.getUTCHours()).padStart(2, '0') + ":" +
            String(date.getUTCMinutes()).padStart(2, '0') + ":" +
            String(date.getUTCSeconds()).padStart(2, '0');
						
          }


          let formattedRes = result.data.map((record: any) => {

            // Format time
            if(record.recordtime){
              const timestamp = this.commonUtil.getZoneTimestampFromUTC(record.zoneid, record.timestamp, record.daylightSavings);
						  record.recordTimeFormatted = formatTimestampToYMDHMS(timestamp);
            }

            //Format Debug Text
            record.debugText = this.commonUtil.getDebugRecordsInfoText({debug: record.debug, info: record.info});
            return record;
          });

          this.DebugRecordsGridData = [...formattedRes];
        }else{
          this.DebugRecordsGridData = [];
        }
      },
      (error) => {
        console.error('Error fetching Debug Records data:', error);
      }
    );
  }

  // /**
  //  * Determine the appropriate grid format based on energy analysis
  //  * @param energyAnalysis - Energy format analysis from backend
  //  * @returns string - Format identifier for grid columns
  //  */
  // determineGridFormat(energyAnalysis: any): string {
  //   if (!energyAnalysis) return 'unknown';

  //   if (energyAnalysis.hasLegacy && energyAnalysis.hasNew) {
  //     return 'both'; // Show all columns when both formats exist
  //   } else if (energyAnalysis.hasNew) {
  //     return 'new'; // Show only new format columns
  //   } else if (energyAnalysis.hasLegacy) {
  //     return 'legacy'; // Show legacy format columns
  //   } else {
  //     return 'unknown'; // Default to showing all columns
  //   }
  // }

  onDebugRecordCellClicked(record) {
    // Handle Debug Record cell click if needed
    console.log('Debug Record clicked:', record.node.data);
  }
}
